import React from 'react';
import { reportActions } from 'actions/ReportActions';
import { reportStore } from 'stores/ReportStore';

import _ from 'lodash';

export class ReportBuildingPopup extends React.Component {
  constructor(props) {
    super(props);
    reportStore.listen(this.storeUpdated.bind(this));
    this.state = reportStore.getState();
  }

  storeUpdated() {
    this.setState(reportStore.getState());
  }

  componentDidUpdate() {
    this.state = this.props;
  }

  closeReportBuildPopup() {
    reportActions.closeReportBuildPopup();
  }

  render() {
    return (
      <div className={`details-popup-wrapper ${this.state.reportBuildingPopupVisible ? '' : 'hidden'}`}>
        <div id={'detailsPopup'} className={'details-popup'}>
          <div className='popup-header blue darken-3'>
            <span>Report Building</span>
            <span className='details-popup-close-icon' onClick={this.closeReportBuildPopup}></span>
          </div>
          {this.state.reportError ? (
            <div className='padding popup-body load-failed'>{this.state.errorMessage}</div>
          ) : (
            <div className='padding popup-body'>
              Your Report is being processed. This may take a few moments. When it is finished it will automatically
              download.
            </div>
          )}
          <div className={'fill_wide padding__long white popup-ok-button'}>
            <a
              className={'waves-effect waves-light btn-large blue darken-4 fill__wide '}
              onClick={this.closeReportBuildPopup}
            >
              OK
            </a>
          </div>
        </div>
      </div>
    );
  }
}
